export default "__VITE_ASSET__D3bmvaGD__"